import * as angular from 'angular';
import {BranchesAlerts} from "./branches-alerts.service";
import {BranchesRequests} from "./branches-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {BranchModel} from "../models/branch.model";

export class BranchesService {

  constructor(private branchesRequests: BranchesRequests, private branchesAlerts: BranchesAlerts, private bringozLoaderService: BringozLoaderService,
              private $log, private $q) {
  }

  updateBranch(id: string, branch: BranchModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.branchesRequests.editBranch(id, branch)
      .then((updatedBranch) => {
        this.branchesAlerts.updateSuccess();
        deferred.resolve(updatedBranch);
      })
      .catch((error) => {
        this.branchesAlerts.updateError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  updateExternalId(id: string, branch: BranchModel) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.branchesRequests.updateExternalId(id, branch)
      .then((updatedBranch: BranchModel) => {
        this.branchesAlerts.updateSuccess();
        deferred.resolve(updatedBranch);
      })
      .catch((error) => {
        this.branchesAlerts.updateError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  getTotalBranches(ids?: string[], tags?: string[], query?: string, isActive?: boolean) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.branchesRequests.getTotalBranches(ids, tags, query, isActive)
      .then((totals) => {
        deferred.resolve(totals);
      })
      .catch((error) => {
        this.$log.error(error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  deleteBranch(id: string) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.branchesRequests.deleteBranch(id)
      .then((deletedBranch) => {
        this.branchesAlerts.deleteOneSuccess(deletedBranch);
        deferred.resolve(deletedBranch);
      })
      .catch((error) => {
        this.$log.error(error);
        this.branchesAlerts.deleteOneError();
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

  editTags(tags: string[], params?: any, branchIds?: string[], excludedBranchIds?: string[]) {
    const deferred = this.$q.defer();

    this.bringozLoaderService.on();
    this.branchesRequests.editTags(tags, params, branchIds, excludedBranchIds)
      .then((res) => {
        this.branchesAlerts.editBranchesTagsSuccess();
        deferred.resolve(res);
      })
      .catch((error) => {
        this.branchesAlerts.editBranchesTagsError();
        this.$log.error(error);
        deferred.reject(error);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      });

    return deferred.promise;
  }

}

angular
  .module('bringoz.admin.branches')
  .service('branchesService', BranchesService);
